import {IHttpService, ILogService, IPromise} from "angular";
import {CPARSearchRequest} from "../model/CPARSearchRequest";
import {CreatePrecedentRequest} from "../model/CreatePrecedentRequest";
import {ExternalUnitSearchRequest} from "../model/ExternalUnitSearchRequest";
import {CreateExternalUnitRequest} from "../model/CreateExternalUnitRequest";

export class CparService {
    /* @ngInject */
    constructor(private $http: IHttpService,
                private $log: ILogService) {
    }

    public createPrecedent(createPrecedentRequest: CreatePrecedentRequest): IPromise<any> {
        return this.$http.post("/api/precedents", createPrecedentRequest).then((resp) => {
            return resp.data;
        });
    }

    public searchCPARPrecedents(cparSearchRequest: CPARSearchRequest) {
        return this.$http.post(`/api/precedents/search`, cparSearchRequest).then((resp) => {
            return resp.data;
        });
    }

    public searchExternalUnit(externalUnitSearchRequest: ExternalUnitSearchRequest): IPromise<any[]> {
        return this.$http.post("/api/precedents/units/search", externalUnitSearchRequest).then((resp) => {
            return [{id: -1, title: "NOT LISTED", unitCode: "CREATE NEW"}, ...resp.data as any[]];
        });
    }

    public createExternalUnit(createExternalUnitRequest: CreateExternalUnitRequest): IPromise<any[]> {
        return this.$http.post("/api/precedents/units", createExternalUnitRequest).then((resp) => {
            return resp.data as any[];
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/cpar/cpar.service.ts